import { render, staticRenderFns } from "./DisciplineType.vue?vue&type=template&id=9cde4a8a"
import script from "./DisciplineType.vue?vue&type=script&lang=js"
export * from "./DisciplineType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports